import dynamic from "next/dynamic";
import { useAppContext } from "@components/Provider";
const AffiliateButton = dynamic(
  () => import("../AffiliateButton/AffiliateButton")
);

const BookInfo = (props) => {
  const {
    affiliate = {
      props: {
        buttonType: "",
        urlType: "",
        buttonText: "",
        linkUrl: {
          url: "",
          title: "",
        },
        title: "",
        amazonLink: "",
        itunesLink: "",
        bnLink: "",
        image: "",
      },
    },
  } = props;
  let { isMobile } = useAppContext();
  return (
    <div style={{textAlign: "center"}} 
    >
      <AffiliateButton
        currentSiteID={props.currentSiteID}
        {...affiliate.props}
        bookInfo={true}
        postType={props.postType}
        className="bookInfoAf"
        isMobile={isMobile}
        freevoice={props.freevoice}
      />
    </div>
  );
};

export default BookInfo;
